import React, { Fragment } from "react"
import { Marker, CenterMarker } from "./Marker"
import GoogleMap from "./GoogleMap"

const isEmpty = (array = []) => (array.length === 0 ? true : false)

const getMapBounds = (map, maps, places) => {
  const bounds = new maps.LatLngBounds()
  places.forEach(place => {
    bounds.extend(
      new maps.LatLng(place.storeCoordinates.latitude, place.storeCoordinates.longitude)
    )
  })
  return bounds
}

const bindResizeListener = (map, maps, bounds) => {
  maps.event.addDomListenerOnce(map, "idle", () => {
    maps.event.addDomListener(window, "resize", () => {
      // map.fitBounds(bounds)
    })
  })
}

const apiIsLoaded = (map, maps, places) => {
  const bounds = getMapBounds(map, maps, places)
  // map.fitBounds(bounds)
  bindResizeListener(map, maps, bounds)
}

function MapComponent({
  defZoom,
  defCenter,
  stores,
  center: [lat, lng],
  selectedStore,
  setSelectedStore,
  setCoordinates,
  mapWidth,
  getStores,
}) {
  // const [places] = useState(stores)
  const handleClick = place => {
    setSelectedStore(place)
    setCoordinates({
      lat: Number(place.storeCoordinates.latitude),
      lng: Number(place.storeCoordinates.longitude),
    })
    getStores(place.storeCoordinates.latitude, place.storeCoordinates.longitude)
  }
  return (
    <Fragment>
      {!isEmpty(stores) && lat && lng && (
        <GoogleMap
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps, stores)}
          center={[lat, lng]}
          zoom={defZoom}
          mapWidth={mapWidth}
          // maxZoom={16}
        >
          <CenterMarker lat={lat} lng={lng} />
          {stores.map((place, ind) => (
            <Marker
              key={ind}
              place={place}
              text={place.storeName}
              address={place.storeAddress}
              lat={place.storeCoordinates.latitude}
              lng={place.storeCoordinates.longitude}
              logo={place.storeLogo}
              selectedStore={selectedStore}
              handleClick={place => handleClick(place)}
            />
          ))}
        </GoogleMap>
      )}
    </Fragment>
  )
}

export default MapComponent
